import { render, staticRenderFns } from "./DataBrick.vue?vue&type=template&id=387efabd&scoped=true"
import script from "./DataBrick.vue?vue&type=script&lang=js"
export * from "./DataBrick.vue?vue&type=script&lang=js"
import style0 from "./DataBrick.vue?vue&type=style&index=0&id=387efabd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../web-components/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387efabd",
  null
  
)

export default component.exports